import React from "react";

const CategoryTag = React.memo(function CategoryTag({ tag, onClick, isActive }) {
  return (
    <span
      data-testid="category-tag"
      className={`inline-flex items-center rounded-full px-2.5 py-1 font-mono text-[11px] tracking-[0.08em] uppercase transition-all duration-150 ${onClick ? 'cursor-pointer' : 'cursor-default'}`}
      style={{
        backgroundColor: '#21262d',
        color: isActive ? '#4ade80' : '#8b949e',
        border: '1px solid #30363d',
        ...(isActive && { boxShadow: '0 0 0 1.5px #4ade80' }),
      }}
      onClick={onClick ? (e) => { e.stopPropagation(); onClick(); } : undefined}
    >
      {tag}
    </span>
  );
});

export default CategoryTag;
